module.exports = __webpack_public_path__ + "static/media/music-screenshot-bts-army.ae61f04e.png";